import {List, Space, Stack} from '@mantine/core';
import {Overview} from "./Overview";
import {PageTitleText} from "./PageTitleText";
import {PageDescriptionText} from "./PageDescriptionText";
import {NormalText} from "./NormalText";
import {CommandAbbreviationText} from "./CommandAbbreviationText";
import {CommandNameText} from "./CommandNameText";
import {CodeBox} from "./CodeBox";
import {PlainTextCodeBox} from "./PlainTextCodeBox";

const inputs = [
    {input: "PRJEB38680"},
    {input: "PRJEB38680,PRJNA230760"},
    {input: "list_of_accession_numbers.txt"},
    {input: "PRJEB38680 --output-dir C:\\Users\\...\\Desktop\\output"},
    {input: "--help"}
]

const codeTexts = inputs.map((input) => {
    return {...input, command: "lagg", subCommand: "ena"};
})

const list = `
PRJEB38680
PRJNA230760
PRJEB25415
`;

export function ENATextSection() {
    return (
        <Stack
            justify="flex-start"
            align="flex-start"
            gap="xl"
            mr="xl"
            ml="xl"
            maw="60rem"
        >
            <Stack
                gap="xs"
                justify="flex-start">

                <Overview/>

                <PageTitleText>
                    ENA
                </PageTitleText>

                <PageDescriptionText>
                    This command is used for utilizing the ENA database.
                </PageDescriptionText>

                <Space h="sm"/>

                <NormalText>
                    The ena command is the primary tool for downloading and processing genomic data from the European
                    Nucleotide Archive (ENA).
                    It supports downloading FASTQ files, performing k-mer counting, and customizing output options for
                    efficient genome data analysis.
                </NormalText>
            </Stack>
            <Stack gap={'m'} id='input'>
                <CommandNameText>
                    Input Argument
                </CommandNameText>

                <NormalText>
                A required argument that can go before or after the option flags.<Space h="xs"/>
                For this command, the input options must be one of the following:
                    <List>
                        <List.Item>An SRA run accession number.</List.Item>
                        <List.Item>A path to a text file containing line-separated SRA run accession numbers. <Space/>
                            To use multiple inputs, provide a comma-separated list of any of the above.</List.Item>
                    </List>
                </NormalText>
                <Space h="sm"/>
                <NormalText>
                    This example below uses a single run accession number to download data:
                </NormalText>
                <CodeBox codeText={codeTexts[0]}/>

                <NormalText>
                    To use multiple accession numbers, simply comma-separate them:
                </NormalText>
                <CodeBox codeText={codeTexts[1]}/>

                <NormalText>
                    You can also use a list to a text file of line-separated run accession numbers like so:
                </NormalText>
                <CodeBox codeText={codeTexts[2]}/>

                <NormalText>
                    list_of_accession_numbers.txt:
                </NormalText>
                <PlainTextCodeBox>{list}</PlainTextCodeBox>
            </Stack>
            
            <Stack gap={'m'} id="output-path">
                <CommandNameText>
                    --output-dir <CommandAbbreviationText> (-o)</CommandAbbreviationText>
                </CommandNameText>

                <NormalText>
                    Use this to specify a specific directory for your downloaded files (and k-mer count files, if counting).
                    If nothing is specified, the default location is where the terminal is located.
                </NormalText>

                <NormalText>
                    Will output the image generated by the accession number PRJEB38680 to a folder named output on the
                    user's Desktop.
                </NormalText>
                <CodeBox codeText={codeTexts[3]}/>
            </Stack>

            <Stack gap={'m'} id="help">
                <CommandNameText>
                    --help
                </CommandNameText>

                <NormalText>
                    Will show the list of command options for ena in the terminal along with default values, input type,
                    and example use cases.
                </NormalText>
                <CodeBox codeText={codeTexts[4]}/>
            </Stack>
        </Stack>
    );
}